<template>
    <div id="contenedor-principal" class="container-fluid">
        <div id="encanezados-vista" class="padding-div-low">
            <h1>CREACIÓN DE REPORTES PARA CÉDULAS CREADAS EN JUZGADO</h1>
        </div>
        <div id="secciones-vista" class="row col-12">
            <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                <div class="area">
                    <h5>Selecciona los parámetros del reporte</h5>
                    <hr />
                    <div class="form-group">
                        <h6>Juzgado</h6> 
                        <C001Area :class="[CAreaFormInformativo ? 'catalogoInformativo p-0 m-0' : 'p-0 m-0']"
                            v-on:valorParaElPadre="evtCambioTipoArea" 
                            v-on:terminoDeCargarAreas="evtTerminoCargadoDeAreas"
                            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                            :idDelInput="catalogoJuzgado.idInput" 
                            :parametros="catalogoJuzgado.parametros" 
                            :valorDefinido="catalogoJuzgado.valorDefinido" 
                            :ref="catalogoJuzgado.refInput"
                            :key="'KJuzgado-VRCAJ' + catalogoJuzgado.contRender"></C001Area>
                    </div>
                    <div v-if="this.campoRequeridoEsValido(catalogoJuzgado.valorDefinido)" class="form-group">
                        <div class="form-group">
                            <h6 class="mt-4" for="fechaFinal">Fecha de envió a dirección</h6>
                            <input type="date" id="fechaFinal" v-model="fechaDeCreacion" class="form-control" />
                        </div>
                        <div class="d-flex justify-content-end mt-4">
                            <button @click="evtAgregarSolictudDeReporte" type="button" class="btn btn-light responsive-width"><i class="fas fa-plus-circle"></i>&nbsp;&nbsp;Agregar solicitud de reporte</button>
                        </div>
                    </div>
                    <div v-if="solicitudDeReportes.length > 0" id="contenedor-solicitud-reportes">
                        <h6>Solicitud de reportes&nbsp;&nbsp;
                            <i id="accion-eliminar-solicitudes" @click="evtLimpiarSolicitudDeReportes" class="fas fa-trash"></i>
                        </h6>
                        <div id="listado-solicitudes-reportes">
                            <div class="row">
                                <div v-for="(solicitud, index) in solicitudesDeReporte" :key="index" class="pr-2 pt-2">
                                    <div class="contenedor-reporte-solicitado">
                                        <span v-if="usuarioEsDeJuzgadoMixto" v-tooltip:right="`${ solicitud.juzgado  } - fecha: ${ solicitud.fechaReporte }`">{{ solicitud.fechaReporte }}</span>
                                        <span v-if="!usuarioEsDeJuzgadoMixto" >{{ solicitud.fechaReporte }}</span>
                                        &nbsp;&nbsp;&nbsp;
                                        <i :id="solicitud.indentificadorSolicitud" @click="evtRemoverSolicitudDeListado($event)" class="fas fa-times"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="advertencias-solicitudes">
                            <i>*Solo se generará reporte de las solicitudes que contengan información.</i>
                        </div>
                        <div class="d-flex justify-content-end mt-4">
                            <button @click="evtCreacionDeReporte" type="button" class="btn btn-primary responsive-width"><i class="fas fa-file"></i>&nbsp;&nbsp;Crear Reporte</button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="visualizarReporte" id="visualizador-reporte-juzgado" class="col-xs-8 col-sm-8 col-md-8 col-lg-8 pl-2 pr-1">
                <PDFDocument 
                  :url="visualizadorDelReporte.url" 
                  :ArchivoAConvertir="visualizadorDelReporte.archivoDeReporte"
                  :EsBase64="EsBase64"
                  :height="visualizadorDelReporte.height"
                  :key="'VRCEAD' + visualizadorDelReporte.contRender" />
            </div>
        </div>
        <!-- MODAL SELECCION DE CEDULAS PARA REPORTE -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="tabla-cedulas-creacion-reporte">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Cédulas creadas en juzgado [Fecha: {{ fechaDeCreacion }}]</h5>
                        <!-- <button id="btn-cerrar-tabla-cedulas-creacion-reporte" @click="limpiarModalSeleccionDeCedulas" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button> -->
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div id="pasos-seleccion-cedulas">
                            <h5><i class="fas fa-info-circle"></i>&nbsp;&nbsp;PASOS :</h5>
                            <h6><strong>1)</strong> Selecciona al menos una cédula de la lista.</h6>
                            <h6><strong>2)</strong> Verifica las cédulas seleccionadas antes de guardar, una vez guardadas las cedulas no se podrá modificar la solicitud del reporte.</h6>
                            <h6><strong>3)</strong> Finaliza la creación de la solicitud del reporte en el botón <strong>Guardar</strong>.</h6>
                        </div>
                        <CTablaGenericaCedulas class="table-responsive mt-4"
                            :idDelInput="cedulasParaCreacionDeReporte.TABLA.ID"
                            :encabezadosColumnas="cedulasParaCreacionDeReporte.TABLA.encabezadosColumnas"
                            :accionesEnTabla="cedulasParaCreacionDeReporte.TABLA.tablaAcciones"
                            :listaDeCedulas="cedulasParaCreacionDeReporte.TABLA.listaMemoria"
                            :conResponsive="true"
                            :ref="cedulasParaCreacionDeReporte.TABLA.REF"
                            v-on:elementosSeleccionados="evtObtenerCedulasSeleccionadas"
                            :key="'KTablaCedulasReportwJZ' + cedulasParaCreacionDeReporte.TABLA.contRender"></CTablaGenericaCedulas>
                        <div id="acciones-seleccion-cedulas" class="d-flex justify-content-end mt-4">
                            <button  type="button" @click="evtGuardarSolicitud" class="btn btn-success mr-3"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                            <button  type="button" @click="limpiarModalSeleccionDeCedulas" class="btn btn-danger"><i class="fas fa-times-circle"></i>&nbsp;&nbsp;Cancelar</button>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import moment from 'moment'
import PDFDocument from '@/../src/components/Comunes/PDFDocument'
import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'
import sistemas from '@/../static/js/sistemas'

export default {
    components: {
        C001Area: catalogos.PJ.C001Area,
        PDFDocument,
        CTablaGenericaCedulas: sistemas.SINOJ.CTablaGenericaCedulas
    },
    directives: {
        tooltipF
    },
    data() {
        return {
            EsBase64:{},
            catalogoJuzgado: {
                idInput: 'CJuzgado-VRCAD',
                refInput: 'RJuzgado-VRCAD',
                parametros: {
                    conMaterias: true,
                    Materias: [ { MateriaId: 2, Activo: true }, { MateriaId: 3, Activo: true }, { MateriaId: 4, Activo: true }, { MateriaId: 5, Activo: true } , { MateriaId: 13, Activo: true }, { MateriaId: 1, Activo: true }, { MateriaId: 12, Activo: true } ]
                },
                valorDefinido: -1,
                nombreJuzgado: null,
                contRender: 1
            },
            fechaDeCreacion: moment().format('YYYY-MM-DD'),
            enumeraciones,
            solicitudDeReportes: [],
            visualizadorDelReporte: {
                url: null,
                height: '700px',
                archivoDeReporte: null,
                contRender: 0
            },
            visualizarReporte: false,
            cargoAreaDeUsuario: false,
            CAreaFormInformativo: false,
            usuarioEsDeJuzgadoMixto: false,
            cedulasParaCreacionDeReporte: {
                TABLA: {
                    ID: 'tabla-seleccion-cedula-rpjz',
                    REF: 'ref-tabla-seleccion-cedula-rpjz',
                    encabezadosColumnas: ['Folio', 'Juzgado','Domicilio','Persona a notificar', 'Consecutivo', 'Tipo de cédula',''],
                    tablaAcciones: { motrarAcciones: true, check: true, eliminar: false, detalles: false },
                    contRender: 0,
                    listaMemoria: []
                },
                lista: [],
                seleccionadas: [],
                solicitudReporteTmp: null
            }
        }
    },
    methods: {
        evtObtenerCedulasSeleccionadas: function(evento) {
            const CEDULAS_TABLA = evento;
            this.cedulasParaCreacionDeReporte.seleccionadas = CEDULAS_TABLA.filter(c => c.enviar);
        },
        obtenerCedulasDeSolicitudDeReporte: async function({ peticion }) {
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SINOJ.sistema.reportes.reporteDeJuzgado.ObtenerCedulasCreadasEnJuzgado;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionArchivos = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticion, headerPeticion);
                const DATOS = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Satisfactorio, Cedulas } = DATOS;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    comun.SeEstaCargandoInformacion(false);
                    console.log(Error);
                    comun.mensajeDeAlerta(mensajeError, null, null);
                } 
                else {
                    if(this.campoRequeridoEsValido(Cedulas) && Cedulas.length > 0) {
                        this.cedulasParaCreacionDeReporte.lista = Cedulas;
                        await Promise.resolve(this.convertirCedulasAFormatoTabla(this.cedulasParaCreacionDeReporte.lista));
                        comun.SeEstaCargandoInformacion(false);
                        $("#tabla-cedulas-creacion-reporte").modal('show');
                    }
                    else {
                        this.cedulasParaCreacionDeReporte.lista = [];
                        this.cedulasParaCreacionDeReporte.TABLA.listaMemoria = [];
                         comun.SeEstaCargandoInformacion(false);
                        comun.mensajeDeAlerta(Satisfactorio);
                    }
                }
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        convertirCedulasAFormatoTabla: async function(cedulas) {
            this.cedulasParaCreacionDeReporte.TABLA.listaMemoria = cedulas.map(cdb => {
                let cedulaObjTabla = {};
                cedulaObjTabla.Folio = cdb.CedulaId;
                cedulaObjTabla.Juzgado = 'Sin juzgado';
                if(this.campoRequeridoEsValido(cdb.Expediente)) { 
                    cedulaObjTabla.Juzgado = (cdb.Expediente.Juzgado != null ) ? cdb.Expediente.Juzgado.Nombre : 'Sin juzgado';
                }
                cedulaObjTabla.Domicilio = 'Sin Domicilio';
                cedulaObjTabla.PersonaANotificar = 'Sin Persona a Notificar';
                if(this.campoRequeridoEsValido(cdb.PersonasANotificar)) {
                    if(cdb.PersonasANotificar[0].Domicilios != null && cdb.PersonasANotificar[0].Domicilios.length > 0) {
                        const DOMICILIO_OBJ = cdb.PersonasANotificar[0].Domicilios[0];
                        let infAdicionalNumExt = (this.campoRequeridoEsValido(DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior)) ? ` ${ DOMICILIO_OBJ.InformacionAdicionalDeNumeroExterior }` : '';
                        let numInterior = (this.campoRequeridoEsValido(DOMICILIO_OBJ.NumeroInterior)) ? `int ${ DOMICILIO_OBJ.NumeroInterior.toString().trim() }` : '';
                        if(this.campoRequeridoEsValido(DOMICILIO_OBJ.Fraccionamiento)) {
                            cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ DOMICILIO_OBJ.Fraccionamiento.Nombre }, ${ DOMICILIO_OBJ.Fraccionamiento.Municipio.Nombre }`;
                        }
                        else {
                            /* 
                                para los casos de domicilios con fraccionamiento que no pertenece al catalogo de fraccionamientos, se guarda la informacion el un solo campo (008FraccionamientoFueraDeCatalogo => FraccionamientoFueraDeCatalogo)
                                con el siguiente formato NOMBRE_FRACCIONAMIENTO, NOMBRE_MUNICIPIO, si se modifica posteriormenete este formato se tendra que reemplazar esta 
                                logica.
                            */
                            let fraccionamientoCompuesto = DOMICILIO_OBJ.FraccionamientoFueraDeCatalogo.split(',');
                            let nombreFraccionamiento = fraccionamientoCompuesto[0];
                            let nombreMunicipio = fraccionamientoCompuesto[1];
                            cedulaObjTabla.Domicilio = `${ DOMICILIO_OBJ.Calle } #${ DOMICILIO_OBJ.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ nombreFraccionamiento }, ${ nombreMunicipio }`;
                        }
                    }
                    
                    if(this.campoRequeridoEsValido(cdb.PersonasANotificar[0].DatosGenerales)) {
                        const { Fisica, Moral } = cdb.PersonasANotificar[0].DatosGenerales;
                        if(this.campoRequeridoEsValido(Fisica))
                            cedulaObjTabla.PersonaANotificar = `${ Fisica.Nombre.toUpperCase().trim() } ${ Fisica.ApellidoPaterno.toUpperCase().trim() }${ (this.campoRequeridoEsValido(Fisica.ApellidoMaterno)) ? (" " + Fisica.ApellidoMaterno.toUpperCase().trim()) : "" }`; 
                        else if(this.campoRequeridoEsValido(Moral))
                            cedulaObjTabla.PersonaANotificar = `${ Moral.Nombre.trim() }`; 
                    }
                }
                cedulaObjTabla.Consecutivo = 'Sin consecutivo';
                if(this.campoRequeridoEsValido(cdb.Expediente)) { 
                    cedulaObjTabla.Consecutivo = cdb.Expediente.NumeroDeDocumento;
                }
                cedulaObjTabla.TipoCedula = this.campoRequeridoEsValido(cdb.TipoCedula.Nombre) ? cdb.TipoCedula.Nombre.trim() : 'Sin tipo de cedula.';
                return cedulaObjTabla;
            });
        },
        evtCreacionDeReporte: function() {
            console.log('this.solicitudDeReportes::',this.solicitudDeReportes);
            let peticion = {};
            peticion.EsPrueba = false;
            peticion.SolicitudesDeReportes = JSON.stringify(this.solicitudDeReportes);
            peticion.conInformacionCompletaDeCedulas = true;
            // let peticion = new FormData();
            // peticion.append('EsPrueba',false);
            // peticion.append('SolicitudesDeReportes',JSON.stringify(this.solicitudDeReportes));
            // peticion.append('conInformacionCompletaDeCedulas',true);
            const SERVIDOR = api.conexion;
            const METODO_API_OBTENER = api.SINOJ.sistema.reportes.reporteDeJuzgado.ObtenerReporteDeCedulasCreadasJuzgado;
            let urlApi = SERVIDOR + METODO_API_OBTENER;
            let peticionArchivos = true;
            this.visualizarReporte = false;
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal);
            comun.SeEstaCargandoInformacion(true);
            axios.post(urlApi, peticion, headerPeticion)
                    .then(respuesta => {      
                        console.log("respuesta::::::",respuesta)      
                        if (respuesta.data.SiHayError) {
                            let mensajeError = respuesta.data.Error.Mensaje;
                            console.log(mensajeError);
                            comun.mensajeDeAlerta(mensajeError, null, null);
                        } 
                        else {
                            const ARCHIVO_DESCARGADO = respuesta.data;
                           // if(ARCHIVO_DESCARGADO != null && ARCHIVO_DESCARGADO.byteLength > 0) {
                            
                                this.EsBase64={
                                  esBase64:true,
                                  archivoBase64:respuesta.data.ArchivoBase64
                                  }
                              //  this.visualizadorDelReporte.archivoDeReporte = new File([ARCHIVO_DESCARGADO], 'ReporteCedulasEnviadasAJuzgado', { type: 'application/pdf' });
                                this.visualizadorDelReporte.contRender ++;
                                this.visualizarReporte = true;
                           // }
                           // else
                            //    comun.mensajeDeAlerta('No se encontro información con los parámetros  ingresados en las solicitudes de reporte');
                        }
                        comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(excepcion);
                        comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
                    }
            ); 
        },
        evtRemoverSolicitudDeListado: function(evento) {
            const IDENTIFICADOR_SOLICITUD = evento.target.getAttribute('id');
            this.solicitudDeReportes = this.solicitudDeReportes.filter(s => s.indentificadorSolicitud != IDENTIFICADOR_SOLICITUD);
        },
        esUnaSolicitudValida: function() { 
            let respuestaDeValidaciones = {};
            respuestaDeValidaciones.esValida = true;
            if(!this.campoRequeridoEsValido(this.fechaDeCreacion)) {
                respuestaDeValidaciones.esValida = false
                respuestaDeValidaciones.mensajeError = "Se detectaron campos incorrectos, <br>Debes ingresar una fecha valida.";
                return respuestaDeValidaciones;
            }

            if(this.fechaDeCreacion > moment().format('YYYY-MM-DD') && (this.catalogoJuzgado.valorDefinido != 57 || this.catalogoJuzgado.valorDefinido != 86)) {                
                respuestaDeValidaciones.esValida = false
                respuestaDeValidaciones.mensajeError = "Se detectaron campos incorrectos,<br>Debes ingresar una fecha menor o igual al dia de hoy.";
                return respuestaDeValidaciones;
            }
            
            if(this.solicitudDeReportes.length > 0) {
                const ID_SOLICITUD_ENVIAR = this.catalogoJuzgado.valorDefinido + this.fechaDeCreacion;
                respuestaDeValidaciones.esValida = !this.solicitudDeReportes.some(s => s.indentificadorSolicitud == ID_SOLICITUD_ENVIAR);
                respuestaDeValidaciones.mensajeError = "Ya has agregado una solicitud de reporte con el juzgado y la fecha ingresada";
            }
            
            return respuestaDeValidaciones;
        },
        evtAgregarSolictudDeReporte: async function() {
            /* verison anterior - 21/06/2021
            let validarSolicitud = this.esUnaSolicitudValida();
            if(validarSolicitud.esValida) {
                const OBJ_SOLICITUD_REPORTE = {
                    indentificadorSolicitud: this.catalogoJuzgado.valorDefinido + this.fechaDeEnvio,
                    id: this.catalogoJuzgado.valorDefinido,
                    juzgado: this.catalogoJuzgado.nombreJuzgado,
                    fechaReporte: this.fechaDeEnvio
                };
                this.solicitudDeReportes.push(OBJ_SOLICITUD_REPORTE);
            }
            else {
                comun.mensajeDeAlerta(validarSolicitud.mensajeError, null, null);
            } */
            const SOLICITUD_VALIDA = this.esUnaSolicitudValida();
            if(SOLICITUD_VALIDA.esValida) {
                this.solicitudReporteTmp = {
                    indentificadorSolicitud: this.catalogoJuzgado.valorDefinido + this.fechaDeCreacion,
                    id: this.catalogoJuzgado.valorDefinido,
                    juzgado: this.catalogoJuzgado.nombreJuzgado,
                    fechaReporte: this.fechaDeCreacion,
                    cedulas: []
                };
                let peticionAPI = new FormData();
                peticionAPI.append('conInformacionCompletaDeCedulas',true);
                peticionAPI.append('EsPrueba',false);
                peticionAPI.append('SolicitudDeReporte',JSON.stringify(this.solicitudReporteTmp));
                await Promise.resolve(this.obtenerCedulasDeSolicitudDeReporte({ peticion: peticionAPI }));
            }
            else {
                comun.mensajeDeAlerta(SOLICITUD_VALIDA.mensajeError, null, null);
            }
        },
        evtGuardarSolicitud: function() {
            const TIENE_CEDULAS_SELECCIONADAS = this.cedulasParaCreacionDeReporte.seleccionadas.some(c => c.enviar);
            if(TIENE_CEDULAS_SELECCIONADAS) {
                this.solicitudReporteTmp.cedulas = this.cedulasParaCreacionDeReporte.seleccionadas.map(c => {
                    let cedulaObj = this.cedulasParaCreacionDeReporte.lista.find(cdb => cdb.CedulaId == c.folio);
                    return {...cedulaObj};
                });
                this.solicitudDeReportes.push(this.solicitudReporteTmp);
                this.limpiarModalSeleccionDeCedulas();
            }
        },
        limpiarModalSeleccionDeCedulas: function() {
            this.cedulasParaCreacionDeReporte.seleccionadas = [];
            this.cedulasParaCreacionDeReporte.TABLA.contRender ++;
            this.solicitudReporteTmp = null;
            $("#tabla-cedulas-creacion-reporte").modal('hide');
        },
        evtCambioTipoArea: function(evento) {
            this.catalogoJuzgado.valorDefinido = parseInt(evento.target.value);
            this.catalogoJuzgado.nombreJuzgado = evento.target.options[evento.target.selectedIndex].text;
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'array' || campo instanceof Array) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo.length > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        },
        evtLimpiarSolicitudDeReportes: function() {
            this.solicitudDeReportes = [];
        },
        asignarValoresDeUsuario: function(areaDeUsuario) {
            if(this.campoRequeridoEsValido(areaDeUsuario)) { 
                const { AreaId, Nombre } = areaDeUsuario;
                this.esJuzgadoMixto(AreaId);
                if(!this.usuarioEsDeJuzgadoMixto) {
                    this.catalogoJuzgado.valorDefinido = this.campoRequeridoEsValido(AreaId) ? AreaId : -1;
                    this.catalogoJuzgado.nombreJuzgado = Nombre;
                    this.catalogoJuzgado.contRender ++
                    this.CAreaFormInformativo = true;
                }
            }
            else {
                this.contRenderArea ++;
                this.CAreaFormInformativo = false;
            }
        },
        esJuzgadoMixto: function(area) {
            const JUZGADOS_MIXTOS = Object.values(enumeraciones.sinoj.juzgadosMixtos);
            if(this.campoRequeridoEsValido(JUZGADOS_MIXTOS)) {
                this.usuarioEsDeJuzgadoMixto = JUZGADOS_MIXTOS.some(jz => jz == area);
                this.evtTerminoCargadoDeAreas();
            }
        },
        evtTerminoCargadoDeAreas: function() {
            if(this.usuarioEsDeJuzgadoMixto) {
                const JUZGADOS_MIXTOS = Object.values(enumeraciones.sinoj.juzgadosMixtos);
                this.$nextTick(() => { debugger
                    const JUZGADOS_VALIDOS = {
                        CIVIL: 2,
                        MERCANTIL: 3,
                        FAMILIAR: 4,
                        PENAL: 6
                    };
                    this.$refs[this.catalogoJuzgado.refInput].Areas = this.$refs[this.catalogoJuzgado.refInput].Areas
                        .filter(a => JUZGADOS_MIXTOS.some(jm => jm == a.AreaId) ||
                        a.Materias.some(m => m.MateriaId == JUZGADOS_VALIDOS.CIVIL || m.MateriaId == JUZGADOS_VALIDOS.MERCANTIL || m.MateriaId == JUZGADOS_VALIDOS.FAMILIAR || m.MateriaId == JUZGADOS_VALIDOS.PENAL));
                    console.log('Areas::',this.$refs[this.catalogoJuzgado.refInput].Areas);
                });
            }
        }
    },
    computed: {
        solicitudesDeReporte() {
            return this.solicitudDeReportes;
        },
        fechaSolicitudTmp() {
            return (this.campoRequeridoEsValido(this.solicitudReporteTmp)) ? this.solicitudReporteTmp.fechaReporte : '';
        }
    },
    async mounted() { 
        if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area)) {
            this.cargoAreaDeUsuario = true;
            await Promise.resolve(this.asignarValoresDeUsuario(this.$store.state.Login_Usuario.Area));
        }
    },
     watch: {
        '$store.state.Login_Usuario.Area': function() {
            if(this.campoRequeridoEsValido(this.$store.state.Login_Usuario.Area) && !this.cargoAreaDeUsuario) {
                this.cargoAreaDeUsuario = true;
                this.asignarValoresDeUsuario(this.$store.state.Login_Usuario.Area);
            }
        }
    }
}
</script>
<style scoped>

#pasos-seleccion-cedulas h6 {
    font-size: 1em;
    margin-bottom: 3px;
}

#listado-solicitudes-reportes {
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 10px;
    padding-top: 6px;
    background-color: #26272b;
    border: 2px solid #5c5959;
}

.responsive-width {
     font-size : 1vw;
}

#contenedor-solicitud-reportes {
    margin-top: 3vw;
}

.contenedor-reporte-solicitado {
    color: #212529;
    background-color: #f8f9fa;
    border-color: #f8f9fa;
    padding: 0.3vw;
    border-radius: 6px;
    max-width: max-content;
    
}

.contenedor-reporte-solicitado span, .contenedor-reporte-solicitado i {
    font-size : 0.7vw;
}

.contenedor-reporte-solicitado i {
    cursor: pointer;
}

#accion-eliminar-solicitudes {
    cursor: pointer;
}

#advertencias-solicitudes i {
    font-size : 0.7vw;
}

.catalogoInformativo {
    pointer-events:none;
    cursor: not-allowed;
    opacity: 0.5;
}

#tabla-cedulas-creacion-reporte .modal-lg {
    max-width: 70% !important;
}

#tabla-cedulas-creacion-reporte .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

#contenedor-principal .area {
    background-color: var(--grs-pj-100);
}

#contenedor-principal h6, #contenedor-principal h5, #contenedor-principal h4 {
    color: black;
}

#contenedor-principal .btn-primary, #contenedor-principal .btn-light {
    background-color: var(--verde-pj-100);
    color: #ffff;
}

#contenedor-principal .modal-header {
    background-color: var(--verde-pj);
}

#contenedor-principal .modal-body {
    background-color: var(--gris-pj-100);
}

</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Reportes/ReportesDeJuzgado/CReporteDeCedulasCreadasEnJuzgado.vue